import React from "react";

export default class StreamMetadata extends React.Component {
    calculateGameState () {
        const game = this.props.game;
        let timestamp = new Date(this.props.streamRecordingTime);
        timestamp.setSeconds(timestamp.getSeconds() + this.props.videoCurrentTime);

        let phase;
        let refGameTime = null;
        let refTimestamp = null;
        if (game.finished_time && timestamp >= new Date(game.finished_time)) {
            phase = "Finished";
        } else if (game.start_of_penalties && timestamp >= new Date(game.start_of_penalties)) {
            phase = "Penalties";
        } else if (game.end_of_2nd_overtime && timestamp >= new Date(game.end_of_2nd_overtime)) {
            phase = "penalties break"
        } else if (game.start_of_2nd_overtime && timestamp >= new Date(game.start_of_2nd_overtime)) {
            phase = "2nd extra time";
            refGameTime = 105;
            refTimestamp = new Date(game.start_of_2nd_overtime);
        } else if (game.end_of_1st_overtime && timestamp >= new Date(game.end_of_1st_overtime)) {
            phase = "overtime break"
        } else if (game.start_of_1st_overtime && timestamp >= new Date(game.start_of_1st_overtime)) {
            phase = "1st extra time";
            refGameTime = 90;
            refTimestamp = new Date(game.start_of_1st_overtime);
        } else if (game.end_of_2nd_half && timestamp >= new Date(game.end_of_2nd_half)) {
            phase = "fulltime break"
        } else if (game.start_of_2nd_half && timestamp >= new Date(game.start_of_2nd_half)) {
            phase = "2nd half";
            refGameTime = 45;
            refTimestamp = new Date(game.start_of_2nd_half);
        } else if (game.end_of_1st_half && timestamp >= new Date(game.end_of_1st_half)) {
            phase = "halftime break"
        } else if (game.start_of_1st_half && timestamp >= new Date(game.start_of_1st_half)) {
            phase = "1st half";
            refGameTime = 0;
            refTimestamp = new Date(game.start_of_1st_half);
        } else {
            phase = "Not started";
        }

        if (refGameTime === null) return phase;

        let timeDiff;
        if (game.stop_periods && game.stop_periods.length > 0) {
            const {diff, isStopped} = this.subtractStoppedTime(game.stop_periods, refTimestamp, timestamp);
            timeDiff = diff;
            if (isStopped) phase = "halted";
        } else {
            timeDiff = (timestamp - refTimestamp);
        }

        let gameSecond = Math.round(timeDiff / 1000) + refGameTime*60;
        let minutes = Math.floor(gameSecond / 60).toFixed(0);
        let seconds = Math.floor(gameSecond % 60).toFixed(0);
        if (minutes.length === 1) { minutes = "0"+minutes; }
        if (seconds.length === 1) { seconds = "0"+seconds; }

        return minutes + ":" + seconds + " (" + phase + ")";
    }

    subtractStoppedTime(periods, refTimestamp, timestamp) {
        let diff = timestamp - refTimestamp;
        let isStopped = false;

        for (let i=0; i<periods.length; i+=2) {
            let start = new Date(periods[i]);
            let stop = periods[i+1] ?
                new Date(periods[i+1]) : new Date (9999999999999);

            if (start >= timestamp || stop <= refTimestamp) {
                // No overlap at all
                continue;
            }
            if (start > refTimestamp) {
                if (stop < timestamp) {
                    // Full overlap
                    diff -= stop - start;
                } else {
                    // The match is currently halted
                    diff -= timestamp - start;
                    isStopped = true;
                }
            } else {
                // Edge cases, shouldnt really be happening
                if (stop < timestamp) {
                    // Partial overlap with ref timestamp
                    diff -= stop - refTimestamp;
                } else {
                    // This shouldnt happen, at least not for more than a couple of seconds
                    diff = 0;
                    isStopped = true;
                }
            }
        }

        return {diff, isStopped};
    }

    calculateGameState2 () {
        const game = this.props.game;
        let timestamp = new Date(this.props.streamRecordingTime);
        timestamp.setSeconds(timestamp.getSeconds() + this.props.videoCurrentTime);

        let phase, gameSecond;
        if (game.finished_time && timestamp >= new Date(game.finished_time)) {
            phase = "Finished";
        } else if (game.start_of_penalties && timestamp >= new Date(game.start_of_penalties)) {
            phase = "Penalties";
            gameSecond = 120 * 60 + (timestamp - new Date(game.start_of_penalties)) / 1000;
        } else if (game.end_of_2nd_overtime && timestamp >= new Date(game.end_of_2nd_overtime)) {
            phase = "penalties break"
        } else if (game.start_of_2nd_overtime && timestamp >= new Date(game.start_of_2nd_overtime)) {
            phase = "2nd extra time";
            gameSecond = 105 * 60 + (timestamp - new Date(game.start_of_2nd_overtime)) / 1000;
        } else if (game.end_of_1st_overtime && timestamp >= new Date(game.end_of_1st_overtime)) {
            phase = "overtime break"
        } else if (game.start_of_1st_overtime && timestamp >= new Date(game.start_of_1st_overtime)) {
            phase = "1st extra time";
            gameSecond = 90 * 60 + (timestamp - new Date(game.start_of_1st_overtime)) / 1000;
        } else if (game.end_of_2nd_half && timestamp >= new Date(game.end_of_2nd_half)) {
            phase = "fulltime break"
        } else if (game.start_of_2nd_half && timestamp >= new Date(game.start_of_2nd_half)) {
            phase = "2nd half";
            gameSecond = 45 * 60 + (timestamp - new Date(game.start_of_2nd_half)) / 1000;
        } else if (game.end_of_1st_half && timestamp >= new Date(game.end_of_1st_half)) {
            phase = "halftime break"
        } else if (game.start_of_1st_half && timestamp >= new Date(game.start_of_1st_half)) {
            phase = "1st half";
            gameSecond = (timestamp - new Date(game.start_of_1st_half)) / 1000;
        } else {
            phase = "Not started";
        }

        let gameState = phase;
        if (gameSecond !== undefined) {

            let minutes = Math.floor(gameSecond / 60).toFixed(0);
            let seconds = Math.floor(gameSecond % 60).toFixed(0);
            if (minutes.length === 1) { minutes = "0"+minutes; }
            if (seconds.length === 1) { seconds = "0"+seconds; }

            gameState = minutes + ":" + seconds + " (" + phase + ")";
        }

        return gameState;
    }

    render () {
        return (
            <div style={this.props.style}>
                {this.props.liveModeEnabled && (
                    <a onClick={this.props.onOpenOptionsMenu} className="live-mode-indicator text-outline">
                        live<br />mode
                    </a>
                )}
                <div className="transparent-black-bg" style={{
                    borderBottomLeftRadius: "8px",
                    height: "54px",
                    padding: "4px",
                    display: "inline-block",
                    float: "left",
                    position: "relative",
                }}>
                    <a className="close text-outline" title="Close stream" onClick={this.props.onCloseClicked} style={{
                        position: "absolute",
                        left: "5px",
                        top: "15px",
                    }}>
                        <span className="glyphicon glyphicon-remove" />
                    </a>
                    <div className="text-outline team-nameplate">
                        <div>{this.props.homeTeam}</div>
                        <div>{this.props.visitingTeam}</div>
                    </div>
                    <a className="close text-outline" title="Stream options" onClick={this.props.onOpenOptionsMenu} style={{
                        position: "absolute",
                        right: "5px",
                        top: "15px",
                    }}>
                        <span className="glyphicon glyphicon-cog" />
                    </a>
                </div>
                <div className="transparent-black-bg" style={{
                    padding: "4px",
                    width: "240px",
                    height: "54px",
                    display: "inline-block",
                    float: "left",
                }}>
                    <div className="btn-group btn-group-lg fullwidth">
                        <a className="btn btn-default text-outline btn-transparent"
                           style={{width: "70%"}} onClick={this.props.onGameStateClick}>
                            {this.calculateGameState()}
                        </a>
                        <a className="btn btn-default text-outline btn-transparent"
                           style={{width: "30%"}}>
                            {this.props.homeTeamGoals} : {this.props.visitingTeamGoals}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/StreamMetadata.js